
import store from '../store';

/**
 * returns the first option obect in the optionsArray having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @param {string} optionsArray option array to search
 * @returns option object
 */
function baseGetOption(optionName, optionsArray = []) {
    return optionsArray.find(element => element.option === optionName);
}

/**
 * returns the first user option obect in the userOptions array having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @returns option object
 */
export function getUserOptionObject(optionName) {
    return baseGetOption(optionName, store.getters.userOptions);
}

/**
 * returns the first user option obect value in the userOptions array having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @returns option object value
 */
export function getUserOption(optionName) {
    const foundOption = getUserOptionObject(optionName);
    return foundOption?.value;
}

/**
 * returns the first company option obect in the companyOptions array having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @returns option object
 */
export function getCompanyOptionObject(optionName) {
    return baseGetOption(optionName, store.getters.companyOptions);
}

/**
 * returns the first company option obect value in the companyOptions array having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @returns option object value
 */
export function getCompanyOption(optionName) {
    const foundOption = getCompanyOptionObject(optionName);
    return foundOption?.value;
}

/**
 * returns the first center option obect in the matching companyCenters __OPTIONS__ array having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @returns option object
 */
export function getCenterOptionObject(center, optionName) {
    const foundCenter = store.getters.companyCenters.find(companyCenter => {
        return (companyCenter.center_id === center
        || companyCenter.center_abbrev === center
        || companyCenter.center_tag === center
        || companyCenter.center_name === center);
    });
    if(foundCenter) {
        return foundCenter.__OPTIONS__.find(element => element.option === optionName);
    }
    return undefined;
}

/**
 * returns the first center option obect value in the matching companyCenters __OPTIONS__ array having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @returns option object value
 */
export function getCenterOption(center, optionName) {
    const foundOption = getCenterOptionObject(center, optionName);
    return foundOption?.value;
}

/**
 * returns the first option obect in either userOptions OR companyOptions array having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @returns option object
 */
export function getOptionObject(optionName) {
    let foundOption = getUserOptionObject(optionName);
    if(!foundOption) {
        return getCompanyOptionObject(optionName);
    }
    return foundOption;
}

/**
 * returns the first option obect value in either userOptions OR companyOptions array having an option property equal to optionName
 * @param {string} optionName option name to search for
 * @returns option object value
 */
export function getOption(optionName) {
    const foundOption = getOptionObject(optionName);
    return foundOption?.value;
}

/**
 * returns an array of any option obects in the optionsArray having an option property that includes the subString
 * @param {string} subString option name to search for
 * @param {string} optionsArray option array to search
 * @returns Array of option objects
 */
function baseFindOptions(subString, optionsArray = []) {
    return optionsArray.filter(element => {
        if(element.option.includes(subString)) {
            return element;
        }
    });
}

/**
 * returns an array of any user option obects in the userOptions having an option property that includes the subString
 * @param {string} subString option name to search for
 * @returns Array of option objects
 */
export function findUserOptionObjects(subString) {
    return baseFindOptions(subString, store.getters.userOptions);
}

/**
 * returns an array of any user option obect values in the userOptions having an option property that includes the subString
 * @param {string} subString option name to search for
 * @returns Array of option object values
 */
export function findUserOptions(subString) {
    const options = findUserOptionObjects(subString);
    return options.map(element => (element.value));
}

/**
 * returns an array of any company option obects in the companyOptions having an option property that includes the subString
 * @param {string} subString option name to search for
 * @returns Array of option objects
 */
export function findCompanyOptionObjects(subString) {
    return baseFindOptions(subString, store.getters.companyOptions);
}

/**
 * returns an array of any company option obect values in the companyOptions having an option property that includes the subString
 * @param {string} subString option name to search for
 * @returns Array of option objects
 */
export function findCompanyOptions(subString) {
    const options = findCompanyOptionObjects(subString);
    return options.map(element => (element.value));
}

/**
 * returns an array of any company or user option obects having an option property that includes the subString
 * @param {string} subString option name to search for
 * @returns Array of option objects
 */
export function findOptionObjects(subString) {
    let foundOptions = findUserOptionObjects(subString);
    if(!foundOptions.length) {
        return findCompanyOptionObjects(subString);
    }
    return foundOptions;
}

/**
 * returns an array of any company or user option obect values having where the option property includes the subString
 * @param {string} subString option name to search for
 * @returns Array of option objects
 */
export function findOptions(subString) {
    const options = findOptionObjects(subString);
    return options.map(element => (element.value));
}
export function getEditUserOptionObject(optionName) {
    return baseGetOption(optionName, store.getters.editUser.userOptions);
}
export function getEditUserOption(optionName) {
    const foundOption = getEditUserOptionObject(optionName);
    return foundOption?.value;
}